import React, { useState } from "react";
import { Card, CardContent } from "../ui";
import { Button } from "../ui";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../ui";
import { useCategories } from "../hooks/useCategories";
import LoadingSpinner from "../common/LoadingSpinner";
import ErrorAlert from "../common/ErrorAlert";
import EmptyState from "../common/EmptyState";
import { toast } from "react-hot-toast";

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../ui/table";

const AdminCategories = ({ setCurrentView, setEditingCategory }) => {
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);

  const {
    categories,
    setCategories, // Agregamos setCategories
    loading,
    error,
    refreshCategories,
    deleteCategory,
  } = useCategories();

  const handleAddCategory = () => {
    setEditingCategory(null);
    setCurrentView("categorias");
  };

  const handleModifyCategory = (category) => {
    const categoryData = {
      id: category.id,
      name: category.name,
      destination: category.destination,
      description: category.description,
      image: category.image,
    };

    setEditingCategory(categoryData);
    setCurrentView("categorias");
  };

  // const handleDeleteClick = (category) => {
  //   setSelectedCategory(category);
  //   setShowDeleteDialog(true);
  // };

  // Dentro del componente AdminCategories

  const handleConfirmDelete = async () => {
    if (!selectedCategory) return;

    setIsDeleting(true);
    try {
      const result = await deleteCategory(selectedCategory._id);

      if (result.success) {
        // Actualizamos el estado local eliminando la categoría
        setCategories((prevCategories) =>
          prevCategories.filter((cat) => cat._id !== selectedCategory._id)
        );
        toast.success(result.message || "Categoría eliminada exitosamente");
      } else {
        toast.error(result.message || "Error al eliminar la categoría");
      }
    } catch (error) {
      toast.error(error.message || "Error al eliminar la categoría");
    } finally {
      setIsDeleting(false);
      setShowDeleteDialog(false);
      setSelectedCategory(null);
    }
  };

  const handleDeleteClick = (category) => {
    console.log("Categoría seleccionada para eliminar:", category); // Para debugging
    setSelectedCategory(category);
    setShowDeleteDialog(true);
  };

  if (loading) return <LoadingSpinner />;
  if (error) return <ErrorAlert message={error} onRetry={refreshCategories} />;
  if (!categories?.length) {
    return (
      <EmptyState
        message="No hay categorías"
        action={
          <Button
            onClick={handleAddCategory}
            className="bg-orange-500 hover:bg-orange-600 text-white"
          >
            Agregar Categoría
          </Button>
        }
      />
    );
  }

  return (
    <div className="p-4 md:p-6 space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold text-gray-900">
          Administrar Categorías
        </h1>
        <Button
          className="bg-orange-500 hover:bg-orange-600 text-white"
          onClick={handleAddCategory}
        >
          Agregar Categoría
        </Button>
      </div>

      <Card className="bg-orange-50 border-orange-200">
        <CardContent className="p-0">
          <Table>
            <TableHeader className="bg-orange-100">
              <TableRow>
                <TableHead className="w-[100px]">Imagen</TableHead>
                <TableHead>Nombre</TableHead>
                <TableHead>Destino</TableHead>
                <TableHead className="text-right">Acciones</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {categories.map((category) => (
                <TableRow key={category.id}>
                  <TableCell className="py-4">
                    <div className="flex items-center justify-center">
                      {category.icon}
                    </div>
                  </TableCell>
                  <TableCell className="font-medium">{category.name}</TableCell>
                  <TableCell>{category.destination}</TableCell>
                  <TableCell className="text-right">
                    <div className="flex justify-end gap-2">
                      <Button
                        variant="outline"
                        className="bg-orange-500 text-white hover:bg-orange-600 border-none"
                        onClick={() => handleModifyCategory(category)}
                      >
                        Modificar
                      </Button>
                      <Button
                        variant="outline"
                        className="bg-orange-500 text-white hover:bg-orange-600 border-none"
                        onClick={() => handleDeleteClick(category)}
                        disabled={isDeleting}
                      >
                        {isDeleting && selectedCategory?.id === category.id
                          ? "Eliminando..."
                          : "Eliminar"}
                      </Button>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>

      {/* Diálogo de confirmación para eliminar */}
      <AlertDialog open={showDeleteDialog} onOpenChange={setShowDeleteDialog}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Confirmar eliminación</AlertDialogTitle>
            <AlertDialogDescription>
              ¿Está seguro que desea eliminar la categoría "
              {selectedCategory?.name}"? Esta acción no se puede deshacer.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel
              className="bg-gray-100 hover:bg-gray-200"
              disabled={isDeleting}
            >
              Cancelar
            </AlertDialogCancel>
            <AlertDialogAction
              onClick={handleConfirmDelete}
              className="bg-orange-500 hover:bg-orange-600"
              disabled={isDeleting}
            >
              {isDeleting ? "Eliminando..." : "Eliminar"}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
};

export default AdminCategories;
